import { Injectable, Inject } from '@angular/core';
import * as auth0 from 'auth0-js';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserInfo } from '../model/model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  auth0: any;
  private _userInfo!: UserInfo;
  private _isLoggedIn = false;
  private _callbackUrl = "/user/callback";
  constructor(public router: Router, private http: HttpClient, @Inject('env') private env: any) 
  {
    const str = localStorage.getItem('isLoggedIn');
    if (str === "true" && this.UserInfo != null)
      this._isLoggedIn = true;

    this.auth0 = new auth0.WebAuth({
      clientID: this.env.Auth0clientID,
      domain: this.env.Auth0domain,
      redirectUri: window.location.origin + this._callbackUrl,
      responseType: 'token id_token',
    });
  }

  public login(): void {
    if(window.location.pathname !== this._callbackUrl){
      this.auth0.authorize();
    }
  }

  public handleAuthentication(): boolean {
    if(window.location.pathname !== this._callbackUrl){
      return true;
    }
    
    this.auth0.parseHash((err: any, authResult: { accessToken: any; idToken: any; idTokenPayload: { [x: string]: any; nickname: any; email: any; sub: any; }; refreshToken: any; tokenType: any; state: any; }) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        console.log('login successful...');
        // console.log(authResult);
        this.isLoggedIn = true;
        this.UserInfo = {
          displayName: authResult.idTokenPayload.nickname,
          userName: authResult.idTokenPayload.email,
          email: authResult.idTokenPayload.email,
          userId: authResult.idTokenPayload.sub,
          availPoint: authResult.idTokenPayload["https://vervotech.com/availPoint"],
          channelId: authResult.idTokenPayload["https://vervotech.com/channelId"],
          firstName: '',
          lastName: ''
        }

        return this.http.post('api/account/auth', {
          'access_token': authResult.accessToken,
          'id_token': authResult.idToken,
          'refresh_token': authResult.refreshToken,
          'token_type': authResult.tokenType,
          'state': authResult.state,
          'channelId': this.UserInfo.channelId
        }).subscribe(res => { }, (e) => {
          this.router.navigate(['']);
        });

      } else if (err) {
        console.error(err);
      }
    });
    return false;
  }

  public logout(): void {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userInfo');
    this.isLoggedIn = false;
    this.auth0.logout({
      returnTo: window.location.origin,
      clientID: this.env.Auth0clientID
    });

  }

  get isLoggedIn(): boolean {
    return this._isLoggedIn;
  }

  set isLoggedIn(val: boolean) {
    if (val)
      localStorage.setItem('isLoggedIn', 'true');
    this._isLoggedIn = val
  }


  get UserInfo(): UserInfo {
    if (this._userInfo == null) {
      const str = localStorage.getItem("userInfo");
      if (str)
        this._userInfo = JSON.parse(str);
    }
    return this._userInfo;
  }

  set UserInfo(val: UserInfo) {
    localStorage.setItem("userInfo", JSON.stringify(val));
    this._userInfo = val
  }

}
